import { render, staticRenderFns } from "./WeeklyFreeGames.vue?vue&type=template&id=f3e1598a&scoped=true&"
import script from "./WeeklyFreeGames.vue?vue&type=script&lang=js&"
export * from "./WeeklyFreeGames.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyFreeGames.vue?vue&type=style&index=0&id=f3e1598a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e1598a",
  null
  
)

export default component.exports